export default __webpack_public_path__ + "static/media/logo-vendeu-ganhou.71f77b5d.png";